import { UpdateProposalProductInputSchema } from "DDD/action-objects/StageProductUpdate";
import { UpdateProposalMaterialNoPlantInput } from "generated/graphql";

const toFiniteNumber = (value: unknown): number | null => {
  if (value === "" || value == null) {
    return null;
  }

  const parsed = typeof value === "number" ? value : Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export const getMaterialNoPlantInputError = (
  materialNoPlants?: UpdateProposalProductInputSchema["materialNoPlants"]
) => {
  const unsavedMaterial = materialNoPlants?.find((item) => !item?.id);

  if (unsavedMaterial) {
    return "A no-plant material is in an incomplete state. Add it again and then retry saving.";
  }

  const invalidPercentage = materialNoPlants?.find((item) => {
    const percentage = toFiniteNumber(item?.percentage);
    return percentage == null || percentage < 0 || percentage > 100;
  });

  if (invalidPercentage) {
    return `${invalidPercentage.name || "Material"} percentage is required and must be between 0 and 100.`;
  }

  const invalidQuantity = materialNoPlants?.find((item) => {
    const quantityOverride = toFiniteNumber(item?.quantityOverride);
    return quantityOverride != null && (!Number.isInteger(quantityOverride) || quantityOverride < 1);
  });

  if (invalidQuantity) {
    return `${invalidQuantity.name || "Material"} quantity must be a whole number.`;
  }

  return null;
};

export const cleanMaterialNoPlants = (
  materialNoPlants?: UpdateProposalProductInputSchema["materialNoPlants"]
): UpdateProposalMaterialNoPlantInput[] =>
  (materialNoPlants ?? []).map((item) => ({
    id: item.id,
    name: item.name,
    percentage: toFiniteNumber(item.percentage) ?? 0,
    rate: toFiniteNumber(item.rate) ?? 0,
    quantityOverride: toFiniteNumber(item.quantityOverride),
  }));
